import { periodForRange, periodRange, validServiceRange } from './servicePeriods';
import { Language, translations } from '../i18n/translations';

export const validCycle = (value: string) =>
  /^\d{4}-[1-6]$/.test(value) &&
  Number(value.slice(0, 4)) >= 2024 &&
  Number(value.slice(0, 4)) <= 2100;
export const currentCycle = () => {
  const today = new Date();
  return `${today.getFullYear()}-${Math.floor(today.getMonth() / 2) + 1}`;
};
export const standardCycle = (value: string) => {
  if (validCycle(value)) return value;
  const candidate =
    validServiceRange(value) && periodForRange(value)
      ? `${value.slice(0, 4)}-${periodForRange(value)}`
      : '';
  return validCycle(candidate) ? candidate : null;
};
export const serviceScope = (cycle: string) =>
  validCycle(cycle) ? periodRange(Number(cycle.slice(0, 4)), Number(cycle.slice(5))) : cycle;
export const cycleLabel = (cycle: string, language: Language) =>
  validCycle(cycle)
    ? `${cycle.slice(0, 4)} ${translations[language][`planning.cycle.period${Number(cycle.slice(5))}`]}`
    : cycle;
